<!--低频 区总页面-->
<template>
    <div class="storageassets-module">
        <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
            <div class="store-box flex-start flex-y-center" v-if="regionPostId.includes(postId)">
                <div @click="openRegionPopup" class="region-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{checkedRegion.name}}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
                <div v-if="checkedStore.id != -1" @click="openRegionStorePopup" class="store-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{checkedStore.name}}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
            </div>
            <div v-show="checkedStore.id == -1">
                <div class="title-box flex-between flex-y-center">
                    <div class="flex-start flex-y-center">
                        <img class="icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/storageAssets/region-icon.png" alt="">
                        <div class="Blacks font34 bold">区域分布</div>
                    </div>
                    <div class="total-amount flex-end">
                        <div class="txt">{{regionData.deadline}}</div>
                    </div>
                </div>
                <div class="unit">单位：人</div>
                <div>
                    <div ref="regionchart" id="regionchart"></div>
                </div>
                <div class="add-up-box flex">
                    <div class="tit">30天内即将低频：<span class="num">{{regionData.nearLowFrequency}}</span></div>
                    <div class="tit">低频会员：<span class="num">{{regionData.lowFrequency}}</span></div>
                </div>
            </div>
            <div class="cut-line" v-if="checkedStore.id == -1"></div>
            <div>
                <div class="title-box flex-between flex-y-center">
                    <div class="flex-start flex-y-center">
                        <img class="icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/storageAssets/store-icon.png" alt="">
                        <div class="Blacks font34 bold">门店分布</div>
                    </div>
                    <div class="total-amount flex-end">
                        <div class="txt">{{storeData.deadline}}</div>
                    </div>
                </div>
                <div class="unit">单位：人</div>
                <div>
                    <div ref="storechart" id="storechart"></div>
                </div>
                <div class="add-up-box flex">
                    <div class="tit">30天内即将低频：<span class="num">{{storeData.nearLowFrequency}}</span></div>
                    <div class="tit">低频会员：<span class="num">{{storeData.lowFrequency}}</span></div>
                </div>
            </div>
            <div class="cut-line"></div>
            <div class="empty-box">
                <div class="flex-col flex-y-center">
                    <img class="empty-icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/storageAssets/empty.png" alt="">
                    <div class="empty-txt">客户详细数据请切换至单门店查看</div>
                </div>
            </div>
        </van-pull-refresh>
        <!-- 区经区总 切换区域 -->
        <van-popup v-model="showRegionPopup" round position="bottom" closeable class="popup">
            <picker title="选择区域" v-model="checkedRegion" :list="regionList" @change="onRegionChange"></picker>
        </van-popup>
        <!-- 区经区总 切换门店 -->
        <van-popup v-model="showRegionStorePopup" round position="bottom" closeable class="popup">
            <picker title="选择门店" v-model="checkedStore" :list="regionStoreList" @change="onRegionStoreChange"></picker>
        </van-popup>
        <!-- 数据筛选 -->
        <van-popup v-model="showRegionSelectPopup" round position="bottom" closeable class="popup">
            <picker title="选择类型" v-model="regionType" :list="typeList" @change="onRegionSelectChange"></picker>
        </van-popup>
        <van-popup v-model="showStoreSelectPopup" round position="bottom" closeable class="popup">
            <picker title="选择类型" v-model="storeType" :list="typeList" @change="onStoreSelectChange"></picker>
        </van-popup>
    </div>
</template>

<script>
import request from "@/utils/request";
import { Toast } from "vant";
import { timestampToYestoday, getYear } from '@/utils/validate';
import { getCookie } from '@/utils'
import { mapState } from 'vuex'
import Picker from '@/components/Picker';
import { getUserLogin, getRegionStoreList, saveRegionStore } from '@/api/home'

export default {
    inject: ['reload'],
    name: "c2LowFrequencyRegionPage",
    components: {
        Picker
    },
    data() {
        return {
            refreshing: false,
            postId: 0, // 岗位
            showRegionPopup: false,
            showRegionStorePopup: false,
            showRegionSelectPopup: false,
            showStoreSelectPopup: false,
            typeList: [
                {
                    id: 1,
                    name: '会员总数'
                },
                {
                    id: 2,
                    name: 'VVIP'
                },
                {
                    id: 3,
                    name: 'V3'
                },
                {
                    id: 4,
                    name: '优质客'
                },
                {
                    id: 5,
                    name: '高潜力'
                },
                {
                    id: 6,
                    name: '基础课'
                },
            ],
            regionStoreList: [],//区域门店列表
            regionList: [],//区域列表
            checkedRegion: { id: -1, name: '' },//所选区域
            checkedStore: {  //所选门店
                name: '',
                id: -1,
            },
            regionData: {},  // 区域数据
            regionType: {   //  区域筛选
                id: 1,
                name: '会员总数'
            },
            storeData: {},  // 门店数据
            storeType: {    //  门店筛选
                id: 1,
                name: '会员总数'
            },
            regionChart: null,
            storechart: null,
            changeId: ''

        };
    },
    computed: {
        ...mapState({
            regionPostId: (state) => {
                return state.user.permissions.regionPostId
            },// 区经区总id
        }),
    },
    mounted() {
        this.postId = getCookie('postId') || localStorage.getItem('postId');
        // 获取当前登陆人所记录的区域门店信息
        getUserLogin().then((res) => {
            if (this.regionPostId.includes(this.postId)) {
                this.checkedRegion.name = res.data.region?.storeName // 当前区域
                this.checkedRegion.id = res.data.region?.id
                if (res.data.store) {
                    this.checkedStore.name = res.data.store.storeName //当前门店
                    this.checkedStore.id = res.data.store.id
                    // 门店列表
                    let params = {
                        id: this.checkedRegion.id
                    }
                    getRegionStoreList(params).then((res) => {
                        this.regionStoreList = res.data
                    })
                }
                // 区域列表
                getRegionStoreList().then((res) => {
                    this.regionList = res.data
                })
                this.onLoad();
            }
        })
    },
    methods: {
        //资产饼图加载
        onLoad() {
            this.initRegionChart()
            this.initStoreChart()
        },
        //柱状图-区域
        async initRegionChart() {
            const _this = this
            this.getRegionData().then(() => {
                // 基于准备好的dom，初始化echarts实例
                var yAxisData = this.regionData.regionY;
                let myEcharts = this.$echarts.init(this.$refs.regionchart);
                window.onresize = myEcharts.resize;
                let options = {
                    grid: {
                        top: "4%",
                        left: "15",
                        bottom: "13%",
                        right: "7%",
                        containLabel: true,
                    },
                    legend: [
                        {
                            itemWidth: 25,
                            itemHeight: 15,
                            textStyle: { color: '#085AFF', fontSize: '14' },
                            data: [{ name: '30天内即将低频：', }],   //rect为矩形
                            bottom: '0',
                            right: '50%'
                        },
                        {
                            itemWidth: 25,
                            itemHeight: 15,
                            textStyle: { color: '#2FD0D5', fontSize: '14' },
                            data: [{ name: '低频会员：', }],   //rect为矩形
                            bottom: '0',
                            right: '15%',
                        },

                    ],
                    tooltip: {
                        borderColor: 'transparent',
                        formatter: "{b} ({c})",
                    },
                    xAxis: [
                        {
                            gridIndex: 0,
                            axisTick: {
                                show: false,
                            },
                            axisLabel: {
                                show: true
                            },
                            splitLine: {
                                show: false
                            },
                            axisLine: {
                                show: false
                            },
                        },
                    ],
                    yAxis: [
                        {
                            gridIndex: 0,
                            interval: 0,
                            data: yAxisData,
                            axisTick: {
                                show: true,
                            },
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: "#35434C",
                                    fontSize: 12
                                },
                                formatter: function (yAxisData) {
                                    var strs = yAxisData.split(''); //字符串数组
                                    var str = ''
                                    for (var i = 0, s; s = strs[i++];) { //遍历字符串数组
                                        str += s;
                                        if (!(i % 12)) str += '\n'; //按需要求余
                                    }
                                    return str
                                }
                            },
                            splitLine: {
                                show: false,
                            },
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: "#6E7079",
                                },
                            },

                        },
                    ],
                    series: [
                        {
                            name: "30天内即将低频：",
                            type: "bar",
                            xAxisIndex: 0,
                            barWidth: "12",
                            barGap: 0,
                            itemStyle: {
                                barBorderRadius: 0,
                                color: '#085AFF',
                            },
                            label: {
                                normal: {
                                    show: true,
                                    position: "right",
                                    textStyle: {
                                        color: "#5087EC",
                                        fontSize: 12
                                    },
                                },
                            },
                            data: this.regionData.nearLowFrequencyX,
                        },
                        {
                            name: "低频会员：",
                            type: "bar",
                            xAxisIndex: 0,
                            barWidth: "12",
                            barGap: 0,
                            itemStyle: {
                                barBorderRadius: 0,
                                color: '#2FD0D5',
                            },
                            label: {
                                normal: {
                                    show: true,
                                    position: "right",
                                    textStyle: {
                                        color: "#68BBC4",
                                        fontSize: 12
                                    },
                                },
                            },
                            data: this.regionData.lowFrequencyX,
                        },
                    ],
                };
                myEcharts.setOption(options);
                // 点击获取该区域id下所有门店的数据
                myEcharts.on('click', params => { // 柱形图点击事件
                    let data = {
                        id: params.data.id,
                        storeId: 0
                    }
                    saveRegionStore(data).then(() => {
                        this.reload()
                    })
                })

            });

        },
        //柱状图-门店
        async initStoreChart() {
            const _this = this
            this.getStoreData().then(() => {
                // 基于准备好的dom，初始化echarts实例
                var yAxisData = this.storeData.regionY;
                let myEcharts = this.$echarts.init(this.$refs.storechart);
                window.onresize = myEcharts.resize;

                let options = {
                    grid: {
                        top: "30",
                        left: "15",
                        bottom: "40",
                        right: "7%",
                        containLabel: true,
                    },
                    legend: [
                        {
                            itemWidth: 25,
                            itemHeight: 15,
                            textStyle: { color: '#085AFF', fontSize: '14' },
                            data: [{ name: '30天内即将低频：', }],   //rect为矩形
                            bottom: '0',
                            right: '50%'
                        },
                        {
                            itemWidth: 25,
                            itemHeight: 15,
                            textStyle: { color: '#2FD0D5', fontSize: '14' },
                            data: [{ name: '低频会员：', }],   //rect为矩形
                            bottom: '0',
                            right: '15%',
                        },

                    ],
                    tooltip: {
                        borderColor: 'transparent',
                        formatter: "{b} ({c})",
                    },
                    xAxis: [
                        {
                            gridIndex: 0,
                            axisTick: {
                                show: false,
                            },
                            axisLabel: {
                                show: true
                            },
                            splitLine: {
                                show: false
                            },
                            axisLine: {
                                show: false
                            },
                        },
                    ],
                    yAxis: [
                        {
                            gridIndex: 0,
                            interval: 0,
                            data: yAxisData,
                            axisTick: {
                                show: true,
                            },
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: "#35434C",
                                    fontSize: 12
                                },
                                formatter: function (yAxisData) {
                                    var strs = yAxisData.split(''); //字符串数组
                                    var str = ''
                                    for (var i = 0, s; s = strs[i++];) { //遍历字符串数组
                                        str += s;
                                        if (!(i % 12)) str += '\n'; //按需要求余
                                    }
                                    return str
                                }
                            },
                            splitLine: {
                                show: false,
                            },
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: "#6E7079",
                                },
                            },

                        },
                    ],
                    series: [
                        {
                            name: "30天内即将低频：",
                            type: "bar",
                            xAxisIndex: 0,
                            barWidth: "12",
                            barGap: 0,
                            itemStyle: {
                                barBorderRadius: 0,
                                color: '#085AFF',
                            },
                            label: {
                                normal: {
                                    show: true,
                                    position: "right",
                                    textStyle: {
                                        color: "#5087EC",
                                        fontSize: 12
                                    },
                                },
                            },
                            data: this.storeData.nearLowFrequencyX,
                        },
                        {
                            name: "低频会员：",
                            type: "bar",
                            xAxisIndex: 0,
                            barWidth: "12",
                            barGap: 0,
                            itemStyle: {
                                barBorderRadius: 0,
                                color: '#2FD0D5',
                            },
                            label: {
                                normal: {
                                    show: true,
                                    position: "right",
                                    textStyle: {
                                        color: "#68BBC4",
                                        fontSize: 12
                                    },
                                },
                            },
                            data: this.storeData.lowFrequencyX,
                        },
                    ],
                };
                myEcharts.setOption(options);
                let H = 0
                if (this.checkedStore.id == 0) {
                    H = 400
                } else {
                    H = options.yAxis[0].data.length * 35
                }
                //将该echarts用之前配置好的option的配置项进行渲染
                var autoHeight = options.xAxis.length * 60 + H
                //获取option配置项中数据源的长度*每个柱状你想设定的高度+150的预留高度
                myEcharts.getDom().style.height = autoHeight + "px"
                //echarts有个getDom（）的方法可以设置获取 ECharts 实例容器的 dom 节点，给节点分别设置高度
                myEcharts.getDom().childNodes[0].style.height = autoHeight + "px"
                // myEcharts.getDom().childNodes[0].childNodes[0].setAttribute("height", autoHeight)
                myEcharts.getDom().childNodes[0].childNodes[0].style.height = autoHeight + "px"
                //根据窗口的大小变动图表
                myEcharts.resize()

                // 跳转
                myEcharts.on('click', params => { // 柱形图点击事件
                    console.log(params);
                    let data = {
                        id: this.checkedRegion.id,
                        storeId: params.data.id
                    }
                    saveRegionStore(data).then(() => {
                        this.$router.replace({
                            path: 'c2LowFrequency',
                        })
                    })
                })

            });

        },
        // 区域分布数据
        getRegionData() {
            return request({
                url: `/low/frequency/region?id=${this.checkedRegion.id}`,
                method: "get",
            })
                .then((res) => {
                    this.regionData = res.data
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        // 门店分布数据
        getStoreData() {
            if (!this.changeId) {
                this.changeId = this.checkedRegion.id
            }
            return request({
                url: `/low/frequency/store?id=${this.changeId}&storeId=${this.checkedStore.id}`,
                method: "get",
            })
                .then((res) => {
                    this.storeData = res.data
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        onRefresh() {
            this.refreshing = false;
            this.onLoad();
        },
        // 筛选区域门店相关
        openRegionPopup() {
            this.showRegionPopup = true
        },
        onRegionChange(data) {
            this.checkedRegion = data
            this.showRegionPopup = false
            this.$nextTick(() => {
                // 提交所选区域记录 storeid 覆盖为0给后端判断是区域变更
                this.checkedStore.id = 0
                let params = {
                    id: this.checkedRegion.id,
                    storeId: this.checkedStore.id
                }
                saveRegionStore(params).then((res) => {
                    this.reload();
                })
            })
        },
        openRegionStorePopup() {
            this.showRegionStorePopup = true
        },
        onRegionStoreChange(data) {
            this.showRegionStorePopup = false
            this.checkedStore = data
            let params = {
                id: this.checkedRegion.id,
                storeId: this.checkedStore.id
            }
            saveRegionStore(params).then(() => {
                if (data.id != 0 && data.id != -1) {
                    this.$router.replace({
                        name: "c2LowFrequency"
                    });
                }
            })
        },
        // 筛选类型
        openRegionSelectPopup() {
            this.showRegionSelectPopup = true
        },
        openStoreSelectPopup() {
            this.showStoreSelectPopup = true
        },
        onRegionSelectChange(data) {
            this.regionType = data
            this.showRegionSelectPopup = false
            this.initRegionChart()
        },
        onStoreSelectChange(data) {
            this.storeType = data
            this.showStoreSelectPopup = false
            this.initStoreChart()
        },
    },
};
</script>

<style scoped lang="less">
.van-pull-refresh {
    min-height: 100%;
}
.storageassets-module {
    height: 100%;
    overflow-y: auto;
}
.store-box {
    padding: 30px 30px;
    padding-bottom: 0;
    background-color: #fff;
    .store-arrow {
        width: 16px;
        height: 26px;
        margin-left: 8px;
        margin-top: 3px;
    }
    .region-name-box {
        min-width: 239px;
        height: 58px;
        background: #f5f5f5;
        border-radius: 35px;
        margin-right: 10px;
        padding: 10px 15px 11px 16px;
    }
    .store-name-box {
        min-width: 187px;
        height: 58px;
        background: #f5f5f5;
        border-radius: 35px;
        padding: 10px 15px 11px 16px;
    }
    .name-txt {
        color: #66757f;
        font-size: 26px;
    }
}

.title-box {
    margin-top: 40px;
    padding: 0 30px;
    .icon {
        width: 40px;
        height: 40px;
        margin-right: 20px;
    }
    .total-amount {
        .txt {
            font-size: 26px;
            color: #a0acb5;
        }
        .select-arrow {
            transform: rotate(90deg);
            font-size: 24px;
            margin-left: 20px;
        }
    }
}

.price-box {
    padding: 27px 30px 0 30px;
    .unit {
        margin-left: 8px;
        margin-right: 30px;
    }
}
.unit {
    margin-right: 34px;
    margin-top: 20px;
    font-size: 26px;
    color: #66757f;
    text-align: right;
}
#regionchart {
    width: 100%;
    height: 449px;
}
#storechart {
    width: 100%;
    height: 449px;
}
.cut-line {
    width: 100%;
    height: 20px;
    background: #f8f8fa;
}
.empty-box {
    height: 416px;
    background-color: #fff;
    padding-top: 50px;
    .empty-icon {
        width: 210px;
        height: 210px;
    }
    .empty-txt {
        font-size: 28px;
        color: #a0acb5;
    }
}
.add-up-box {
    padding: 30px 0 50px 0;
    justify-content: center;
    > .tit {
        font-size: 24px;
        color: #a0acb5;
        .num {
            font-weight: 700;
            color: #35434c;
        }
    }
    > .tit:nth-child(1) {
        margin-right: 58px;
    }
}
</style>

